import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Typography, 
  Box,
  Paper
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SettingsIcon from '@material-ui/icons/Settings';
import SettingsNavigation, { SettingsNavigationPage } from '../../organisms/settings/SettingsNavigation';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
  },
  icon: {
    fontSize: 80,
    color: theme.palette.grey[400],
    marginBottom: theme.spacing(2),
  },
}));

const SettingsPage: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('companies');
  
  return (
    <SettingsNavigation selected={SettingsNavigationPage.Intro}>
      <Box p={3}>
        <Typography variant="h4" gutterBottom>
          {t('title')}
        </Typography>
        
        <Paper className={classes.paper}>
          <Box display="flex" flexDirection="column" alignItems="center">
            <SettingsIcon className={classes.icon} />
            <Typography variant="h5" gutterBottom>
              Welkom bij de instellingen
            </Typography>
            <Typography variant="body1" color="textSecondary" paragraph style={{ maxWidth: '600px', marginTop: '16px' }}>
              Hier kunt u verschillende instellingen van de databank beheren. 
              Gebruik het menu onderaan deze pagina om toegang te krijgen tot de verschillende instellingsopties.
            </Typography>
            <Typography variant="body2" color="textSecondary" style={{ maxWidth: '600px', marginTop: '8px' }}>
              De beschikbare opties zijn afhankelijk van uw toegangsrechten. 
              Neem contact op met een beheerder als u toegang nodig heeft tot bepaalde instellingen.
            </Typography>
          </Box>
        </Paper>
      </Box>
    </SettingsNavigation>
  );
};

export default SettingsPage;

